import React from "react";
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';

const CustomPagination = (props) => {
    const { totalPages, page, size = "small", setPage } = props;
    return (
        <Stack spacing={2}
            style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: '5px 0 10px 0'
            }}
        >
            <Pagination
                //variant="outlined"
                color="primary"
                count={totalPages}
                page={page}
                size={size}
                onChange={(e, page) => setPage(page)}
            />
        </Stack>
    )
}

export default CustomPagination;